import { PropTypes as MobxPropTypes, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownItem } from 'reactstrap';

import globalTranslations from '../../../i18n/globalTranslations';
import Language from '../../../models/Language';
import { modelOf } from '../../../prop-types';
import { countryCodeFromLocale } from '../../../util/languageMapper';
import DropdownSelect from '../DropdownSelect';
import LocaleFlagIcon from '../LocaleFlagIcon';

const RegionalSettingsLanguageDropdown = ({
  language,
  languages,
  onSelect,
}) => {
  return (
    <DropdownSelect
      className="RegionalSettingsLanguageDropdown"
      focusSelectedItemOnKeyboardOpen
      label={
        <FormattedMessage
          {...globalTranslations.languageLabel}
          values={{
            language: (
              <span className="RegionalSettingsLanguageDropdown__selected-item">
                <LocaleFlagIcon
                  locale={countryCodeFromLocale(language.code)}
                  decorative
                />
                {language.name}
              </span>
            ),
          }}
        />
      }
    >
      {languages.map((languageOption) => {
        const isActive = language.code === languageOption.code;

        return (
          <DropdownItem
            key={languageOption.code}
            className="RegionalSettingsLanguageDropdown__item"
            onClick={() => onSelect(languageOption)}
            active={isActive}
            aria-current={isActive ? 'true' : undefined}
          >
            <span>
              <LocaleFlagIcon
                locale={countryCodeFromLocale(languageOption.code)}
                decorative
              />
              {languageOption.name}
            </span>
          </DropdownItem>
        );
      })}
    </DropdownSelect>
  );
};

RegionalSettingsLanguageDropdown.propTypes = {
  language: modelOf(Language).isRequired,
  languages: MobxPropTypes.observableArrayOf(modelOf(Language)).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default observer(RegionalSettingsLanguageDropdown);
